import { ViewModel } from "../mvvm/ViewModel.js";
/** About page copy stored as one JSON document in site content. */
export class AboutContentViewModel extends ViewModel {
    client;
    slug;
    options;
    constructor(client, slug, options) {
        super({ data: null, loading: false, saving: false, error: null });
        this.client = client;
        this.slug = slug;
        this.options = options;
    }
    async load() {
        const data = await this.run(async () => {
            let loaded = null;
            if (this.client.getAccessToken()) {
                try {
                    const content = await this.client.getSiteContent(this.slug);
                    if (content.about?.trim().startsWith("{"))
                        loaded = JSON.parse(content.about);
                }
                catch {
                    // fall through to shipped copy
                }
            }
            loaded ??= await this.options.fallback();
            this.setState({ data: loaded });
            return loaded;
        }, "Failed to load site content.");
        return data ?? null;
    }
    /** Optimistic: shows `next` immediately, reloads from the server when the save fails. */
    async save(next) {
        this.setState({ data: next, error: null });
        if (!this.client.getAccessToken()) {
            await this.load();
            this.setState({ error: "Sign in to edit site content." });
            return false;
        }
        this.setState({ saving: true });
        try {
            await this.client.updateSiteContent(this.slug, {
                about: JSON.stringify(next),
                ...(this.options.mirrorFields?.(next) ?? {}),
            });
            this.setState({ saving: false });
            return true;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : "save failed";
            this.setState({ saving: false });
            await this.load();
            this.setState({ error: message });
            return false;
        }
    }
}
//# sourceMappingURL=AboutContentViewModel.js.map